import { StyledText } from "../common/styled-text"

export function HeaderText() {
  return (
    <>
      <StyledText className="text-base-black">Crash the</StyledText>
      <StyledText className="text-base-black">
        <br />
        Group Chat
      </StyledText>

      <p className="font-regular mt-4 mt-8 font-inter text-18 leading-[30px] text-base-black opacity-80 md:max-w-[615px] md:text-24">
        Epic group chats hosted by your favorite podcasters, politicos, reality stars, athletes,
        comedians & more
      </p>
    </>
  )
}
